<script setup lang="ts">
const { t: $t } = useI18n()

import type { RentalPricingMachineryTypeFilter } from '~/server/trpc/routers/shop/rentalPricing'
import { machineryRubrics } from '~/server/schemas'

const filters = defineModel<RentalPricingMachineryTypeFilter>({ required: true })

function resetFilters() {
  filters.value = {}
}

const { machineryDrive: queryMachineryDrive } = useQuery()
const { data: machineryDrives } = queryMachineryDrive.all(false)

const machineryDrivesOptions = computed(() => machineryDrives.value?.map(drive => ({
  label: $t(`machinery.drive.${drive.name}`),
  value: drive.id,
})) ?? [])
const rubricOptions = useTranslatedSelectOptions('machinery.rubric', machineryRubrics.options)
</script>

<template>
  <FormKit
    v-model="filters"
    type="form"
    :actions="false"
  >
    <div class="grid grid-cols-2 gap-x-4">
      <div class="MinMaxContainer">
        <p>{{ $t('machinery.field.liftingWeight.name') }}</p>
        <div class="MinMaxInput">
          <FormKitNumberNaiveUi
            name="minLiftingWeight"
            :prefix="$t('general.min')"
            :min="0"
          />
          <FormKitNumberNaiveUi
            name="maxLiftingWeight"
            :prefix="$t('general.max')"
            :min="0"
          />
        </div>
      </div>

      <div class="MinMaxContainer">
        <p>{{ $t('machinery.field.liftingHeight.name') }}</p>
        <div class="MinMaxInput">
          <FormKitNumberNaiveUi
            name="minLiftingHeight"
            :prefix="$t('general.min')"
            :min="0"
          />
          <FormKitNumberNaiveUi
            name="maxLiftingHeight"
            :prefix="$t('general.max')"
            :min="0"
          />
        </div>
      </div>
      <div class="MinMaxContainer">
        <p>{{ $t('machinery.field.workHeight.name') }}</p>
        <div class="MinMaxInput">
          <FormKitNumberNaiveUi
            name="minWorkHeight"
            :prefix="$t('general.min')"
            :min="0"
          />
          <FormKitNumberNaiveUi
            name="maxWorkHeight"
            :prefix="$t('general.max')"
            :min="0"
          />
        </div>
      </div>
      <FormKitMultiSelect
        name="driveId"
        :label="$t('machinery.field.drive.name')"
        :multi-select-options="machineryDrivesOptions"
        :is-multi-select-allowed="false"
        is-clearable
      />
      <FormKitMultiSelect
        name="machineryRubric"
        :label="$t('machinery.field.rubric.name')"
        :multi-select-options="rubricOptions"
        :is-multi-select-allowed="false"
        is-clearable
      />
    </div>
    <n-button
      type="primary"
      @click="resetFilters"
    >
      {{ $t('common.resetAll') }}
    </n-button>
  </FormKit>
</template>

<style scoped>
.MinMaxContainer {
  @apply flex flex-col gap-2;
}

.MinMaxContainer p {
  @apply font-bold;
}

.MinMaxInput {
  @apply flex gap-2;
}
</style>
